import { Outlet, Link, useLocation } from 'react-router-dom';
import { useContext, useState } from 'react';
import { AuthContext } from '../App';
import { Button } from './ui/button';
import { LayoutDashboard, FileText, Users, Building2, UserCircle, MessageSquare, LogOut, BarChart3, Menu, X } from 'lucide-react';

export default function Layout() {
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path;
  
  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const navItems = [
    { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/solicitacoes', icon: FileText, label: 'Solicitações' },
    { path: '/clientes', icon: Users, label: 'Clientes' },
    { path: '/fornecedores', icon: Building2, label: 'Fornecedores' },
    { path: '/relatorios', icon: BarChart3, label: 'Relatórios' },
    { path: '/whatsapp', icon: MessageSquare, label: 'WhatsApp' },
  ];

  if (user?.funcao === 'gerente') {
    navItems.push({ path: '/usuarios', icon: UserCircle, label: 'Usuários' });
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
      {/* Botão Menu Mobile */}
      <button
        onClick={toggleMenu}
        className="fixed top-4 left-4 z-50 lg:hidden bg-white p-2 rounded-lg shadow-md hover:bg-slate-100 transition-colors"
        aria-label="Menu"
      >
        {menuOpen ? <X size={24} className="text-slate-800" /> : <Menu size={24} className="text-slate-800" />}
      </button>

      {/* Backdrop para Mobile */}
      {menuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={closeMenu}
        />
      )}

      {/* Sidebar */}
      <aside className={`fixed left-0 top-0 h-full w-64 bg-white border-r border-slate-200 shadow-sm z-50 transition-transform duration-300 ease-in-out ${
        menuOpen ? 'translate-x-0' : '-translate-x-full'
      } lg:translate-x-0`}>
        <div className="p-6 border-b border-slate-200">
          <h1 className="text-2xl font-bold text-slate-800">Efraim Clube</h1>
          <p className="text-sm text-slate-500 mt-1">Sistema de Reservas</p>
        </div>

        <nav className="p-4 space-y-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={closeMenu}
                data-testid={`nav-${item.label.toLowerCase()}`}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                  active
                    ? 'bg-blue-600 text-white shadow-md'
                    : 'text-slate-600 hover:bg-slate-100'
                }`}
              >
                <Icon size={20} />
                <span className="font-medium">{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-slate-200">
          <div className="mb-3 px-2">
            <p className="text-sm font-medium text-slate-700">{user?.nome}</p>
            <p className="text-xs text-slate-500">{user?.funcao}</p>
          </div>
          <Button
            onClick={logout}
            variant="outline"
            className="w-full justify-start"
            data-testid="logout-btn"
          >
            <LogOut size={18} className="mr-2" />
            Sair
          </Button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="lg:ml-64 p-4 lg:p-8 pt-16 lg:pt-8">
        <Outlet />
      </main>
    </div>
  );
}